module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_summary03-002a20c94d54d9c0753fa3e4570afc5a.png";